type ViteEnv = {
  PROD: boolean;
  VITE_GOOGLE_MAPS_GEOCODING_API_KEY: string;
  VITE_SENTRY_DSN?: string;
  VITE_SENTRY_ENV?: string;
  VITE_WEATHERLAYERS_API_KEY: string;
  VITE_STATIC_TILE_CACHE_DOMAIN: string;
  VITE_TILE_SERVER_URL: string;
  VITE_FIREBASE_ANALYTICS_WEB_CONFIG: string;
  VITE_MAPBOX_ACCESS_TOKEN: string;
  VITE_RECURLY_PUBLIC_TOKEN: string;
  VITE_RADIO_TOWERS_URL: string;
  VITE_MAPBOX_API: string;
  VITE_AIRCRAFT_TRACE_ENDPOINT: string;
  VITE_AIRCRAFT_LIST_ENDPOINT: string;
  VITE_BASE_API_URL: string;
  VITE_BASE_SHARE_URL: string;
  VITE_BASE_WEB_URL: string;
  VITE_GIT_SHA: string;
  VITE_GIT_TAG?: string;
  VITE_ENV: string;
  VITE_DEBUG_PUSH_TOKEN?: string;
  VITE_SHOW_UPGRADE_MESSAGE: boolean;
  VITE_POSTHOG_PUBLIC_KEY: string;
  VITE_POSTHOG_ENV?: string;
  VITE_FULLSTORY_ORG_ID: string;
  VITE_3D_MAPS_ENABLED: boolean;
};

export const ENV: ViteEnv = Object.entries(import.meta.env).reduce(
  (acc, [key, value]) => {
    // Convert any true/false strings to booleans, which aren't supported by the
    // native import.meta.env object.
    if (['true', 'false'].includes(value)) {
      return {
        ...acc,
        [key]: value === 'true',
      };
    }

    if (!Number.isNaN(Number(value))) {
      return {
        ...acc,
        [key]: Number(value),
      };
    }

    return {
      ...acc,
      [key]: value,
    };
  },
  {} as ViteEnv,
);
